import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface AdminRouteProps {
  children: JSX.Element;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { token, isAdmin } = useSelector((state: RootState) => state.auth);
  if (!token) return <Navigate to="/login" />;
  if (!isAdmin) return <Navigate to="/dashboard" />;
  return children;
};
